// extracted by mini-css-extract-plugin
export default {"warn":"Warn_warn__NbY4f","icon":"Warn_icon__lHa0Z","title":"Warn_title__L4GNv","big":"Warn_big__5icgW","description":"Warn_description__OYKqd"};